import React from 'react';

export default function YoutubeIcon({ width = 48, height = 47, fill = '#171C33' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect x="0.18457" width="47" height="47" fill="url(#pattern0_15388_35576)" />
      <defs>
        <pattern
          id="pattern0_15388_35576"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_15388_35576" transform="scale(0.01)" />
        </pattern>
        <image
          id="image0_15388_35576"
          width="100"
          height="100"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEjklEQVR4nO2dXYhUZRjH/xptWVlUGBTdKF2UH5UsmO08z5kopbqxz10tto+7bsQo+oJg+vQqCK3cvIiIJSRIu0iyBUMK2UKQLsok66KWskINg1Jxwf5xzsws20XZ7Hlm3vc9PT/4Xwwzs/C8v3ln33POvM8BHMdxHMdxHMdxHMdxHMdxHMdxHMdxooV1nE3BhUXquJyCBa1cTUF/kRpuKNJ+3Hyu+brme5rvvwVnha4nKrgcc1jHFaxBmGGIGR6mYj0Vm6jYQsUOCj6lYD8FP1Fwggoa53jxtxVfUTBOwQcUvE3Ba1S8SME6Ku6ioEbF/PwDgVThClzADEspuJuCJyjYTMXO1gD/1oXBZY/yKxX7KBijYoSKx5jhTg7gWi7D+YiF/CuAgnuoeK/1qeP/NAcp2EbBmmBfi8UsUExEMBiMLBP57OmdiEGcQcUrERTOqCPYQGB294W4DHYg5fVuy3gweJGaWATD3ZExgLkUHAleoCYWwWGuxLn2QprHDOEL1CSz1l6IYncEhTHJCD6xP32hmAxemCabSdMjfmZYEkFRTDoZllgfBIYvShNOhiFLIU8HL0gTj+AZSyFvBS9Ik88WSyG7IiiIieczSyHfBC1m+CpyaH7oAS0Xwc92QhTHghbTGCQnT5LvbiRvnht+cGeWP9mPc8rLuAkXBy+mMcgpDh8k199PZrNCD3DnqePK8kJqWBSVkDb795APXRd+kDtJhpXlhWTQKIXknDpFjo2Sqy5JRci95YUobotWSJvfj5KbnyRv7As/6P8WwbpqXANpnEZIm4mvycdvjVnIC+WFCB5NRkib8e3k6gXVvIJIwfPJCcmJcZks2Goh5KUkhcS5TN5RXohiY9JCYlomC3ZZCBmphJAYlsmC8fJCBG9URkj4ZfJeixkyWjkh4ZbJ+yxmyDuVFdLrZbLgWxcS13HLgfJC/CuLhjPkc4sZ4v/U1Sy7LWaIL3vVbIaMWQjxA0M1E7KtvBA/dULDjFoI8ZOLapZNFkIeCV5IoyKn3xXPlheieCB4IY2KXKCy2JbADKuCF9KozCXcNeWF5Jv8QxfSqMiPHAQrLIT4z4DUKBmWlheyHBdFJeTQjzEtYzuLYF5pIYUUwR/BhUxGuYztJMcJzLIRojgQtJjhCvzY2uJM7zQhH0VQEBPPTjshvmGHBnnTUohvadPSecpSiG/61JKx7BDEOhYHL0gTTw2LLIV44wCNqHFAIcVba7BEPjaVUQjx5jOMq/lMHed5eybMJIe60p6pkCK4L4ICmVQsTrmfRsqG4EVqMhnpqoxCCDDbpeC/5OWeNMGcElPDHVR8H0HhjCqC7/KNsj0T8TcpC9FHxep8q1bRTDj0YGjQRspbi/bpC9GHWMjbbrOGayi4vdgsKniViu0UfEHBLwl/6o8UrcYVH0bdanxGMyq/W0GG61v739dS8VyrF/AoFe8XB6CCLyn4oUsXxo61ZvM/N+Nv9q5Pvxl/N2A/zpy63YTi0mm3oVg87fYU9Vaaj/OWhO3XDeAyv12F4ziO4ziO4ziO4ziO4ziO4ziO4zhIgr8AGnhQ+kZOM8sAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
}
